module.exports = __webpack_public_path__ + "static/media/shape2_2.90a55f0d.obj";